/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free molarity and mass molarity calculator. Enter any three of mass, molar concentration, volume and molecular weight to solve the fourth. Mix units freely.`)
};

const es_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de molaridad y masa molar. Introduce tres de los cuatro valores (masa, concentración molar, volumen y peso molecular) para calcular el cuarto. Combina unidades libremente.`)
};

const de_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Molaritäts- und Massenmolaritätsrechner. Geben Sie drei von Masse, molarer Konzentration, Volumen und Molekulargewicht ein, um die vierte Größe zu berechnen. Einheiten können frei gemischt werden.`)
};

const nl_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis molariteit- en massamolariteitcalculator. Vul drie van de vier waarden in — massa, molaire concentratie, volume en molecuulgewicht — om de vierde te berekenen. Eenheden vrij te combineren.`)
};

const fr_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de molarité et de masse. Entrez trois valeurs parmi la masse, la concentration molaire, le volume et la masse moléculaire pour résoudre la quatrième. Mélangez les unités librement.`)
};

const it_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di molarità e massa molare. Inserisci tre qualsiasi tra massa, concentrazione molare, volume e peso molecolare per risolvere il quarto. Unità liberamente combinabili.`)
};

const pt_br2_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de molaridade e massa molar. Informe três dos quatro valores — massa, concentração molar, volume e peso molecular — para resolver o quarto. Misture unidades livremente.`)
};

const pt_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de molaridade e massa. Introduza quaisquer três valores entre massa, concentração molar, volume e massa molecular para calcular o quarto. Misture unidades livremente.`)
};

const ja_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のモル濃度・質量モル濃度計算ツール。質量、モル濃度、体積、分子量のうち3つを入力すると、残り1つを計算します。単位は自由に混在できます。`)
};

const zh_massmol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费摩尔浓度与质量摩尔浓度计算器。输入质量、摩尔浓度、体积和分子量中任意三项，求解第四项。可自由混用单位。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_meta_description", locale)
	if (locale === "en") return en_massmol_meta_description(inputs)
	if (locale === "es") return es_massmol_meta_description(inputs)
	if (locale === "de") return de_massmol_meta_description(inputs)
	if (locale === "nl") return nl_massmol_meta_description(inputs)
	if (locale === "fr") return fr_massmol_meta_description(inputs)
	if (locale === "it") return it_massmol_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_meta_description(inputs)
	if (locale === "pt") return pt_massmol_meta_description(inputs)
	if (locale === "ja") return ja_massmol_meta_description(inputs)
	return zh_massmol_meta_description(inputs)
};